import { FC } from "react";
import { useAlertStore, useThemeStore } from "../stores";
import { Column, Row } from "../components/containers";
import { JustifyContent } from "../components/containers/types";
import { Heading } from "../components/typography";
import { IconAnimation } from "../components/animation";
import { CloseIcon } from "../assets/icons";
import { AlertClickFn } from "./types";

const Alerts: FC = () => {
  const theme = useThemeStore((s) => s.theme);

  const { alerts, rmAlert } = useAlertStore();

  const onClick = (id: number, cb?: AlertClickFn): void => {
    rmAlert(id);
    if (cb) cb();
  };

  return (
    <Column style={styles.container} gap={10}>
      {alerts.map((alert) => (
        <Row
          key={alert.id}
          background={theme.background}
          style={styles.alert}
          justifyContent={JustifyContent.Between}
          className="transition"
          props={{ onClick: () => onClick(alert.id, alert.onClick) }}
        >
          <Heading
            color={alert.type === "error" ? theme.alert : theme.secondary}
          >
            {alert.msg}
          </Heading>

          <IconAnimation
            Icon={CloseIcon}
            onHoverColor={theme.alert}
            width={20}
            height={20}
            className="cursor-pointer"
          />
        </Row>
      ))}
    </Column>
  );
};

export default Alerts;

const styles: Record<string, React.CSSProperties> = {
  container: {
    position: "absolute",
    right: 20,
    top: 20,
    maxWidth: 392,
    width: "calc(100% - 40px)",
    zIndex: 999999999,
  },
  alert: {
    padding: "0 16px 0 8px",
    minHeight: 40,
    boxShadow: `0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)`,
    borderRadius: 7,
    width: "calc(100% - 24px)",
    cursor: "pointer",
  },
};
